import { lazy, Suspense } from 'react';
import type { AnswerWidgetRenderer } from './widgets/answerWidgetRenderer.ts';

const InternalMarkdown = lazy(() =>
  import('./InternalMarkdown.tsx').then(module => ({ default: module.InternalMarkdown }))
);

export type MarkdownProps = {
  content: string;
  fontSize?: number;
  widgets?: Record<string, unknown> | undefined;
  renderWidget?: AnswerWidgetRenderer | undefined;
};

/**
 * @param {string} content - The content to render as markdown.
 * @param {number} [fontSize] - Opt-in font size override. Omit to keep theme typography (body2).
 * @param {AnswerWidgetRenderer} [renderWidget] - Opt-in renderer for widget kinds beyond the default table/chart.
 * @returns A lazy-loaded markdown component.
 */
export function Markdown({ content, fontSize, widgets, renderWidget }: MarkdownProps) {
  return (
    <Suspense fallback={<div>{content}</div>}>
      <InternalMarkdown content={content} fontSize={fontSize} widgets={widgets} renderWidget={renderWidget} />
    </Suspense>
  );
}
